import React, { useState, useEffect, useRef } from 'react'

export const EuropamundoVacations = () => {
    const [iframeLoaded, setIframeLoaded] = useState(false);

    return (
        <div className='pt-150'>
            {!iframeLoaded && (
                <div className="iframe-loader">
                <div className="spinner"></div>
                </div>
            )}
            <iframe
                id="frame_cmp"
                src="https://www.europamundo.com/eng/embed/multisearch.aspx?opeIP=499&ageKEY=47004"

                frameBorder="0"
                scrolling="auto"
                style={{
                    width: "100%",
                    overflowX: "hidden",
                    // minHeight: "600px"
                    minHeight: "1000px",
                }}
                data-opeid="499"
                data-ageid="47004"
                title="Europamundo Iframe"
                onLoad={() => setIframeLoaded(true)}
            ></iframe>
        </div>
    )
}
